import React from 'react';

/**
 * ImproveDescriptionPreview Component
 * Uses .btn-modal-primary (gray) for modal preview buttons
 */
const ImproveDescriptionPreview = ({ improvedDescription, onAccept, onReject, accepting, acceptLabel = 'Accept & Use' }) => {
  return (
    <div className="modal-overlay" onClick={onReject}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Improved Description Preview</h3>
          <button className="modal-close" onClick={onReject}>×</button>
        </div>

        <div className="improve-preview-content">
          <div className="improve-preview-box">
            {improvedDescription}
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" onClick={onReject} className="btn-secondary" disabled={accepting}>
            Reject
          </button>
          <button type="button" onClick={onAccept} className="btn-modal-primary" disabled={accepting}>
            {accepting ? 'Updating...' : acceptLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImproveDescriptionPreview;
